module.exports = __webpack_public_path__ + "static/media/icon_events.465150f7.png";